/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import React, { useState, useEffect } from 'react';
import { css, StyleSheet } from 'aphrodite';
import { mixins } from '@blend/consumer-components';
import { ProvideTimers, TimerProps } from '@blend/shared-react';

import { NotaryAPI } from '../../../api/notary/types';
import { notaryAPI } from '../../../api/notary';
import { useRootSelector } from '../../../hooks/useRootSelector';
import { EventItem } from './EventItem';

export namespace EventList {
  export interface OwnProps {}

  export type Props = OwnProps & TimerProps;
}

const eventRefreshInterval = 1500;

const styles = StyleSheet.create({
  wrapper: {
    ...mixins.padding(12, 8),
    ...mixins.borderBottom(1, 'solid', mixins.globalBorderColor),
    ':last-child': {
      borderBottom: 'none',
    },
  },
});

const _EventList: React.FC<EventList.Props> = ({ reactSafeSetInterval }) => {
  const { callDetails } = useRootSelector(state => state);
  const [events, setEvents] = useState<NotaryAPI.CallEventsResponse>([]);

  useEffect(() => {
    const interval = reactSafeSetInterval(async () => {
      setEvents(await notaryAPI.calls.fetchCallEvents(callDetails!.id));
    }, eventRefreshInterval);
    return () => clearInterval(interval);
  }, [callDetails!.id]);

  return (
    <div className={css(styles.wrapper)} data-it="EventList">
      {events.map(e => (
        <EventItem key={e.id} {...e} />
      ))}
    </div>
  );
};

export const EventList = (props: EventList.OwnProps) => (
  <ProvideTimers render={timerProps => <_EventList {...props} {...timerProps} />} />
);
